import { api } from './client'
import { withCustomerIds } from './params'

export function fetchThreatDownSummary(customerIds = []) {
  return api
    .get('/threatdown/summary', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchThreatDownEndpoints(params, customerIds = []) {
  return api
    .get('/threatdown/endpoints', { params: withCustomerIds(params, customerIds) })
    .then((r) => r.data)
}

export function fetchThreatDownEndpoint(endpointId) {
  return api.get(`/threatdown/endpoints/${endpointId}`).then((r) => r.data)
}

export function fetchThreatDownEndpointDetections(endpointId, params = {}) {
  return api
    .get(`/threatdown/endpoints/${endpointId}/detections`, { params })
    .then((r) => r.data)
}

export function fetchThreatDownDetections(params, customerIds = []) {
  return api
    .get('/threatdown/detections', { params: withCustomerIds(params, customerIds) })
    .then((r) => r.data)
}
